// ============================================================
// QUESTS — Échos de mémoire de l'Éveillé
//
// A quest is a linked list of steps. Each step has a trigger
// (matched in gameSaga). Reaching a step with no `next` completes
// the quest and grants `rewards`.
// ============================================================

import { ZONE_TYPES } from './constants';

export const QUEST_TRIGGER = {
    HERO_MOVE: 'hero_move',
    FIGHT_VICTORY: 'fight_victory',
    ENTER_ZONE: 'enter_zone',
    ENTER_CITY: 'enter_city',
    SHOP_OPENED: 'shop_opened',
};

export const QUESTS = {
    awakening: {
        id: 'awakening',
        title: 'L\'Éveil',
        startStep: 'firstSteps',
        steps: {
            firstSteps: {
                description: 'Faites trois pas dans la Vallée de dana',
                trigger: { type: QUEST_TRIGGER.HERO_MOVE, count: 3 },
                next: 'firstFight',
            },
            firstFight: {
                description: 'Survivez à votre première rencontre',
                trigger: { type: QUEST_TRIGGER.FIGHT_VICTORY },
                next: 'godricHollow',
            },
            godricHollow: {
                description: 'Trouvez Godric\'s Hollow',
                trigger: { type: QUEST_TRIGGER.ENTER_ZONE, zoneType: ZONE_TYPES.CITY },
                next: 'firstShop',
            },
            firstShop: {
                description: 'Visitez l\'une des boutiques de Godric',
                trigger: { type: QUEST_TRIGGER.SHOP_OPENED },
                next: null,
            },
        },
        rewards: { xp: 100, gold: 50 },
    },
};

// Returns the next active quest after `current` is completed (or null).
export const getNextQuest = (completedIds) => {
    const ids = Object.keys(QUESTS);
    for (const id of ids) {
        if (!completedIds.includes(id)) return id;
    }
    return null;
};
